const DISMISS_MENU_ITEM_KEY = 'doBox.newReply.dismissMenuItem';
const DISMISS_ALL_MENU_ITEM_KEY = 'doBox.newReply.dismissAllMenuItem';

// A menu item names what it reaches: one reply, or all of them.
export const dismissNewRepliesMenuItemKey = (messageCount: number): string =>
  messageCount > 1 ? DISMISS_ALL_MENU_ITEM_KEY : DISMISS_MENU_ITEM_KEY;
